export default function isHiddenEarlyAccessVariant(variant) {
  return (
    !window.theme.eligibleForEarlyAccess && JSON.parse(variant.earlyAccess)
  );
}
